var _defs, _rect, _rect2, _rect3, _text, _path, _path2, _path3, _rect4, _text2, _rect5, _text3, _path4, _rect6, _text4, _path5, _rect7, _text5, _path6, _rect8, _text6, _path7, _path8, _rect9, _text7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "321px",
    height: "322px",
    viewBox: "-0.5 -0.5 321 322",
    content: "<mxfile host=\"Electron\" modified=\"2024-11-21T17:03:45.382Z\" agent=\"Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/23.1.5 Chrome/120.0.6099.109 Electron/28.1.0 Safari/537.36\" version=\"23.1.5\" etag=\"lQMio4o2NMxgsYLibfSp\" type=\"device\" scale=\"1\" border=\"0\"> <diagram name=\"Page-1\" id=\"NfGBYTge6UAcRK7_LgBI\"> <mxGraphModel dx=\"2045\" dy=\"642\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"850\" pageHeight=\"1100\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <mxCell id=\"2\" value=\"\" style=\"whiteSpace=wrap;html=1;aspect=fixed;fillColor=#292929;strokeColor=#23445d;\" vertex=\"1\" parent=\"1\"> <mxGeometry width=\"320\" height=\"320\" as=\"geometry\" /> </mxCell> <mxCell id=\"3\" value=\"&lt;b&gt;&lt;font style=&quot;font-size: 16px;&quot;&gt;Visualizer Legend&lt;/font&gt;&lt;/b&gt;\" style=\"text;html=1;align=center;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontColor=#FDFFFC;\" vertex=\"1\" parent=\"1\"> <mxGeometry width=\"160\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"4\" value=\"\" style=\"html=1;shape=mxgraph.basic.isocube;isoAngle=15;fillColor=#e3c800;fontColor=#000000;strokeColor=#B09500;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"20\" y=\"60\" width=\"40\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"5\" value=\"\" style=\"endArrow=none;dashed=1;html=1;rounded=0;fillColor=#e51400;strokeColor=#B20000;strokeWidth=3;\" edge=\"1\" parent=\"1\"> <mxGeometry width=\"50\" height=\"50\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"20\" y=\"174.76\" as=\"sourcePoint\" /> <mxPoint x=\"65\" y=\"174.76\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"6\" value=\"Satellite sensing node\" style=\"text;html=1;align=left;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontColor=#F2F2F2;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"90\" y=\"65\" width=\"120\" height=\"30\" as=\"geometry\" /> </mxCell> <mxCell id=\"7\" value=\"High-usage/Violated link\" style=\"text;html=1;align=left;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontColor=#F5F5F5;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"92.5\" y=\"160\" width=\"140\" height=\"30\" as=\"geometry\" /> </mxCell> <mxCell id=\"8\" value=\"\" style=\"endArrow=none;dashed=1;html=1;rounded=0;fillColor=#1ba1e2;strokeColor=#006EAF;strokeWidth=3;\" edge=\"1\" parent=\"1\"> <mxGeometry width=\"50\" height=\"50\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"20\" y=\"214.76\" as=\"sourcePoint\" /> <mxPoint x=\"65\" y=\"214.76\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"9\" value=\"Medium-usage link\" style=\"text;html=1;align=left;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontColor=#ffffff;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"92.5\" y=\"200\" width=\"140\" height=\"30\" as=\"geometry\" /> </mxCell> <mxCell id=\"10\" value=\"\" style=\"endArrow=none;dashed=1;html=1;rounded=0;fillColor=#60a917;strokeColor=#2D7600;strokeWidth=3;\" edge=\"1\" parent=\"1\"> <mxGeometry width=\"50\" height=\"50\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"20\" y=\"254.76\" as=\"sourcePoint\" /> <mxPoint x=\"65\" y=\"254.76\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"11\" value=\"Low-usage link\" style=\"text;html=1;align=left;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontColor=#ffffff;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"92.5\" y=\"240\" width=\"140\" height=\"30\" as=\"geometry\" /> </mxCell> <mxCell id=\"12\" value=\"\" style=\"endArrow=none;html=1;rounded=0;fillColor=#60a917;strokeColor=#bababa;strokeWidth=3;\" edge=\"1\" parent=\"1\"> <mxGeometry width=\"50\" height=\"50\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"20\" y=\"294.76\" as=\"sourcePoint\" /> <mxPoint x=\"65\" y=\"294.76\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"13\" value=\"Orbit line\" style=\"text;html=1;align=left;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontColor=#ffffff;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"92.5\" y=\"280\" width=\"140\" height=\"30\" as=\"geometry\" /> </mxCell> <mxCell id=\"14\" value=\"\" style=\"html=1;shape=mxgraph.basic.isocube;isoAngle=15;fillColor=#004C99;fontColor=#000000;strokeColor=#007FFF;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"20\" y=\"110\" width=\"40\" height=\"40\" as=\"geometry\" /> </mxCell> <mxCell id=\"15\" value=\"Satellite processor node\" style=\"text;html=1;align=left;verticalAlign=middle;whiteSpace=wrap;rounded=0;fontColor=#F2F2F2;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"90\" y=\"115\" width=\"140\" height=\"30\" as=\"geometry\" /> </mxCell> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 320,
    height: 320,
    fill: "#292929",
    stroke: "#23445d",
    pointerEvents: "all"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 160,
    height: 40,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 158,
      height: 1,
      paddingTop: 20,
      marginLeft: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FDFFFC; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(253, 255, 252)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 16
    }
  }, "Visualizer Legend")))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 24,
    fill: "#FDFFFC",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "Visualizer Legend")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 40 60 L 60 69.6 L 60 90.4 L 40 100 L 20 90.4 L 20 69.6 Z",
    fill: "#e3c800",
    stroke: "#b09500",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 20 69.6 L 40 79.21 L 60 69.6 M 40 79.21 L 40 100",
    fill: "none",
    stroke: "#b09500",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 20 174.76 L 65 174.76",
    fill: "none",
    stroke: "#b20000",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "9 9",
    pointerEvents: "stroke"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 65,
    width: 120,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 118,
      height: 1,
      paddingTop: 80,
      marginLeft: 92
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #F2F2F2; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(242, 242, 242)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Satellite sensing node")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 84,
    fill: "#F2F2F2",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Satellite sensing no...")))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 160,
    width: 140,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 138,
      height: 1,
      paddingTop: 175,
      marginLeft: 95
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #F5F5F5; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(245, 245, 245)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "High-usage/Violated link")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 179,
    fill: "#F5F5F5",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "High-usage/Violated link")))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 20 214.76 L 65 214.76",
    fill: "none",
    stroke: "#006eaf",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "9 9",
    pointerEvents: "stroke"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 200,
    width: 140,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 138,
      height: 1,
      paddingTop: 215,
      marginLeft: 95
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #ffffff; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Medium-usage link")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 219,
    fill: "#ffffff",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Medium-usage link")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 20 254.76 L 65 254.76",
    fill: "none",
    stroke: "#2d7600",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "9 9",
    pointerEvents: "stroke"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 240,
    width: 140,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 138,
      height: 1,
      paddingTop: 255,
      marginLeft: 95
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #ffffff; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Low-usage link")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 259,
    fill: "#ffffff",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Low-usage link")))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 20 294.76 L 65 294.76",
    fill: "none",
    stroke: "#bababa",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 92.5,
    y: 280,
    width: 140,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 138,
      height: 1,
      paddingTop: 295,
      marginLeft: 95
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #ffffff; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(255, 255, 255)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Orbit line")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 299,
    fill: "#ffffff",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Orbit line")))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 40 110 L 60 119.6 L 60 140.4 L 40 150 L 20 140.4 L 20 119.6 Z",
    fill: "#004c99",
    stroke: "#007fff",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 20 119.6 L 40 129.21 L 60 119.6 M 40 129.21 L 40 150",
    fill: "none",
    stroke: "#007fff",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 115,
    width: 140,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe flex-start",
      width: 138,
      height: 1,
      paddingTop: 130,
      marginLeft: 92
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #F2F2F2; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(242, 242, 242)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Satellite processor node")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 92,
    y: 134,
    fill: "#F2F2F2",
    fontFamily: "Helvetica",
    fontSize: "12px"
  }, "Satellite processor node"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegend);
export default __webpack_public_path__ + "static/media/legend.cdbab1c03010afc18e14a301e29454ae.svg";
export { ForwardRef as ReactComponent };